<template>
  <el-dialog
      :title="$t('text.confirmAmount')"
      :visible="isShowAmountEditDialog"
      width="600px"
      @close="closeDialog"
  >
    <div class="custom-label-item">
      <div
          class="custom-label"
          :style="{ width: formLabelWidth }"
      >
        {{ $t('text.cardName') }}
      </div>
      <div class="custom-content">
        {{ amountEditData.receiverCardAccount + ' - ' + getCardTypeName(amountEditData.cardType) }}
      </div>
    </div>

    <div class="custom-label-item">
      <div
          class="custom-label"
          :style="{ width: formLabelWidth }"
      >
        {{ $t('text.currentBalanceOfCollection') }}
      </div>
      <div class="custom-content">
        {{ $formatter.FenToYuanToThousandth(null, null, amountEditData.balance, null) }}
      </div>
    </div>


    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item :label="$t('text.amount')" :label-width="formLabelWidth" prop="balance">
        <el-input type="text" v-model="form.balance" autocomplete="off" :placeholder="$t('text.inputAmount')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('text.remark')" :label-width="formLabelWidth" prop="remark">
        <el-input
            size="small"
            type="textarea"
            v-model="form.remark"
            :placeholder="$t('message.inputRemark')"
        ></el-input>
      </el-form-item>

    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button :disabled="loading" @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" :loading="loading" @click="confirm">{{ $t('text.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  props: {
    isShowAmountEditDialog: Boolean,
    amountEditData: {
      type: Object,
      required: true
    },
    cardTypeList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      formLabelWidth: "100px",
      form: {
        balance: "",
        remark: "",
      },
      loading: false,
      rules: {
        balance: [
          {
            required: true,
            message: this.$t('message.inputAmount'),
            trigger: ["blur", "change"]
          }
        ],
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:isShowAmountEditDialog', false);
    },
    confirm() {
      this.loading = true

      const params = {
        cardId: this.amountEditData.cardId,
        balance: this.form.balance,
        remark: this.form.remark,
      }

      this.axios.put("/card/modifyCardBalance", params)
          .then(res => {
            if (res.code === 200) {
              this.isShowAmountEditDialog = false;
              this.$message.success(this.$t('message.editAgentSuccess'));
              this.$emit('refresh-card-list');
              this.cancel();
              this.loading = false;
            } else {
              this.$notify.error({
                title: this.$t('text.operationFailed'),
                message: res.msg,
              });
            }
          }).finally(() => {
        this.loading = false;
      })
    },
    getCardTypeName(value) {
      return this.cardTypeList.filter(x => x.value === value)[0].name;
    },
  }
}
</script>

<style scoped>

.custom-label-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px; /* 行间距 */
}

.custom-label {
  text-align: left; /* 文本靠右 */
  margin-right: 10px; /* 与内容间距 */
}

.custom-content {
  flex: 1; /* 内容占满剩余空间 */
  padding-bottom: 10px;
}

</style>
